import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'button inline-flex items-center justify-center gap-1.5 px-2 leading-none focus-visible:outline-2 disabled:cursor-default disabled:opacity-35 disabled:outline-none',
  {
    variants: {
      variant: {
        textLink: '', // needed for the type. Classes are set in compoundVariants.
        link: 'text-color-text-dark px-0 underline underline-offset-2',
        'icon-flat': 'rounded border-none px-0',
        'icon-only': 'px-0',
        'color-button':
          'enabled:hover:border-color-grey border-color-grey-light border-2 border-solid group-[.color-button-active]:outline-2 group-[.color-button-active]:outline-black group-[.color-button-rounded]:rounded-full',
      },
      color: {
        default:
          'bg-color-grey-light [&:not(:disabled)]:hover:bg-color-grey focus-visible:bg-color-grey border-color-text-darktransparent focus-visible:outline-color-text-dark-transparent border',
        primary:
          'button-primary text-color-primary-contrasttext focus-visible:outline-color-primary focus-visible:outline-color-text-dark',
        secondary:
          'button-secondary text-color-secondary-contrasttext focus-visible:outline-color-secondary',
        additional:
          'bg-color-additional text-color-text-light [&:not(:disabled)]:hover:bg-color-additional-dark focus-visible:bg-color-additional-dark focus-visible:outline-color-additional',
        success:
          'bg-color-success text-color-text-light [&:not(:disabled)]:hover:bg-color-success-dark focus-visible:bg-color-success-dark focus-visible:outline-color-success',
        warning:
          'bg-color-warning text-color-text-dark [&:not(:disabled)]:hover:text-color-text-light [&:not(:disabled)]:hover:bg-color-warning-dark focus-visible:bg-color-warning-dark focus-visible:outline-color-warning focus-visible:text-color-text-light',
        error:
          'bg-color-error text-color-text-light [&:not(:disabled)]:hover:bg-color-error-dark focus-visible:bg-color-error-dark focus-visible:outline-color-error',
        sale: 'bg-color-sale text-color-sale-contrasttext [&:not(:disabled)]:hover:bg-color-sale-dark focus-visible:bg-color-sale-dark focus-visible:outline-color-sale',
        drupal:
          'text-color-text-dark bg-color-drupal-primary focus-visible:outline-color-text-light rounded-full outline-offset-2',
      },
      size: {
        base: '',
        small:
          'text-size-body-xs min-h-3.5 [&>[class^="icon-emp"]]:h-2.5 [&>[class^="icon-emp"]]:w-2.5',
        medium:
          'text-size-body-sm min-h-[36px] [&>[class^="icon-emp"]]:h-4 [&>[class^="icon-emp"]]:w-4',
        large:
          'text-size-body-base min-h-[44px] [&>[class^="icon-emp"]]:h-4 [&>[class^="icon-emp"]]:w-4',
      },
    },
    defaultVariants: {
      size: 'medium',
      color: 'default',
    },
    compoundVariants: [
      {
        variant: 'textLink',
        color: 'default',
        size: ['large', 'medium', 'small', 'base'],
        className:
          'bg-color-transparent [&:not(:disabled)]:hover:bg-color-transparent focus-visible:bg-color-transparent focus-visible:standard-focus-outline min-h-auto rounded-none border-0 p-0 underline underline-offset-2',
      },
      {
        variant: 'color-button',
        size: 'small',
        className: 'h-[30px] min-h-[30px] w-[30px] min-w-[30px] p-0',
      },
      {
        variant: ['icon-only', 'icon-flat'],
        size: 'small',
        className: 'h-3.5 w-3.5',
      },
      {
        variant: ['icon-only', 'icon-flat'],
        size: 'medium',
        className: 'h-[36px] w-[36px]',
      },
      {
        variant: ['icon-only', 'icon-flat'],
        size: 'large',
        className: 'h-[44px] w-[44px]',
      },
      {
        variant: 'icon-flat',
        color: [
          'additional',
          'default',
          'error',
          'primary',
          'sale',
          'secondary',
          'success',
          'warning',
        ],
        className:
          'bg-color-transparent text-color-text-dark [&:not(:disabled)]:focus-visible:standard-focus-outline',
      },
      {
        variant: 'link',
        size: ['large', 'medium', 'small'],
        className:
          'bg-color-transparent hover:bg-color-transparent enabled:hover:bg-color-transparent enabled:focus-visible:outline-color-text-dark-transparent enabled:focus-visible:bg-color-transparent h-auto border-none',
      },
    ],
  },
);
